import { useState, useEffect } from "react";

const WhatsAppButton = () => {
  const [visible, setVisible] = useState(false);
  const [pulse, setPulse] = useState(true);
  const [bannerDismissed, setBannerDismissed] = useState(false);
  const [bannerVisible, setBannerVisible] = useState(false);

  useEffect(() => {
    const dismissed = sessionStorage.getItem("whatsapp_banner_dismissed");
    if (dismissed) setBannerDismissed(true);

    const timerBtn = setTimeout(() => setVisible(true), 1200);
    const timerPulse = setTimeout(() => setPulse(false), 5000);
    const timerBanner = setTimeout(() => setBannerVisible(true), 2500);

    return () => {
      clearTimeout(timerBtn);
      clearTimeout(timerPulse);
      clearTimeout(timerBanner);
    };
  }, []);

  const handleDismiss = () => {
    setBannerDismissed(true);
    sessionStorage.setItem("whatsapp_banner_dismissed", "1");
  };

  const showBanner = bannerVisible && !bannerDismissed;

  return (
    <>
      {/* ── Banner CTA flutuante — apenas mobile ── */}
      <div
        className={`md:hidden fixed bottom-0 left-0 right-0 z-50 transition-transform duration-500 ${
          showBanner ? "translate-y-0" : "translate-y-full"
        }`}
        style={{ willChange: "transform" }}
      >
        <div className="bg-white border-t border-gray-100 px-4 py-3 flex items-center gap-3">
          {/* Ícone */}
          <div className="w-10 h-10 flex items-center justify-center bg-green-500 rounded-full flex-shrink-0">
            <i className="ri-whatsapp-line text-white text-xl"></i>
          </div>

          {/* Texto */}
          <div className="flex-1 min-w-0">
            <p className="text-xs font-extrabold text-gray-900 leading-tight">Fale agora pelo WhatsApp</p>
            <p className="text-[11px] text-gray-400 leading-tight">Atendimento rápido e direto</p>
          </div>

          {/* CTA */}
          <a
            href="https://wa.link/lo7hfn"
            target="_blank"
            rel="nofollow noreferrer"
            className="flex-shrink-0 px-4 py-2 bg-green-500 text-white text-xs font-extrabold rounded-full whitespace-nowrap cursor-pointer"
          >
            Iniciar chat
          </a>

          {/* Fechar */}
          <button
            type="button"
            onClick={handleDismiss}
            aria-label="Fechar banner"
            className="w-7 h-7 flex items-center justify-center rounded-full bg-gray-100 flex-shrink-0 cursor-pointer ml-1"
          >
            <i className="ri-close-line text-gray-500 text-sm"></i>
          </button>
        </div>
      </div>

      {/* ── Botão flutuante redondo — desktop ── */}
      <div
        className={`hidden md:flex fixed bottom-6 right-6 z-50 flex-col items-end gap-3 transition-all duration-500 ${
          visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        {/* Tooltip */}
        <div className="bg-gray-950 text-white text-xs font-bold px-4 py-2 rounded-full whitespace-nowrap animate-bounce">
          Fale com a gente! 👋
        </div>

        {/* Botão principal */}
        <a
          href="https://wa.link/lo7hfn"
          target="_blank"
          rel="nofollow noreferrer"
          aria-label="Falar pelo WhatsApp"
          className="relative w-14 h-14 flex items-center justify-center bg-green-500 hover:bg-green-600 text-white rounded-full transition-all hover:scale-110 cursor-pointer"
          style={{ boxShadow: "0 4px 24px rgba(34,197,94,0.45)" }}
        >
          {pulse && (
            <span className="absolute inset-0 rounded-full bg-green-400 animate-ping opacity-60"></span>
          )}
          <i className="ri-whatsapp-line text-2xl relative z-10"></i>
        </a>
      </div>
    </>
  );
};

export default WhatsAppButton;
